import { jsx, jsxs } from "react/jsx-runtime";
import { cx } from "@/styled-system/css";
import { FormField, Box, Label, Tooltip, Paragraph } from "@zillow/constellation-10";
import React, { useState, useEffect, useMemo } from "react";
import ReactSlider from "react-slider";
import { currencyFormatter } from "../../RentVsBuyCalculator.mixins.esm.js";
import { gridWithMargin, styledSlider, gridWithPadding, gridEnd, sliderLabel, formFieldWrapper, trackActive, trackInactive, thumb } from "./CustomSlider.styles.esm.js";
const Thumb = ({
  props,
  state,
  id,
  percentageQuestion
}) => {
  const {
    className: propsClassName,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx("div", { "data-testid": `expense-${id}-thumb`, className: cx(thumb, propsClassName), ...restProps, children: /* @__PURE__ */ jsx("div", { className: "upper-tooltip", children: percentageQuestion ? `${state.value}%` : `$${currencyFormatter(state.value, 2)}` }) });
};
const Track = (props, state) => {
  const {
    key,
    className: propsClassName,
    ...restProps
  } = props;
  return /* @__PURE__ */ jsx("div", { ...restProps, className: cx(state.index === 0 ? trackActive : trackInactive, propsClassName) }, key);
};
const InputTooltip = ({
  toolTipHeader,
  toolTipStatement
}) => /* @__PURE__ */ jsxs(Tooltip.Root, { children: [
  /* @__PURE__ */ jsx(Tooltip.Trigger, {}),
  /* @__PURE__ */ jsx(Tooltip.Portal, { children: /* @__PURE__ */ jsxs(Tooltip.Content, { children: [
    /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsx(Paragraph, { children: toolTipHeader }),
      /* @__PURE__ */ jsx("br", {}),
      /* @__PURE__ */ jsx(Paragraph, { children: toolTipStatement })
    ] }),
    /* @__PURE__ */ jsx(Tooltip.Arrow, {})
  ] }) })
] });
const CustomSlider = ({
  id,
  min,
  max,
  step,
  defaultValue,
  percentageQuestion,
  onChange,
  onAfterChange,
  sliderQuestion,
  toolTipHeader,
  toolTipStatement
}) => {
  const [sliderValue, setSliderValue] = useState(defaultValue);
  useEffect(() => {
    setSliderValue(defaultValue);
  }, [defaultValue]);
  const formField = useMemo(() => {
    return /* @__PURE__ */ jsx(FormField, { label: /* @__PURE__ */ jsx(Label, { htmlFor: id, "data-testid": `${id}-label`, children: /* @__PURE__ */ jsxs("span", { className: sliderLabel, children: [
      sliderQuestion,
      toolTipHeader && toolTipStatement && /* @__PURE__ */ jsx(InputTooltip, { toolTipHeader, toolTipStatement })
    ] }) }), control: /* @__PURE__ */ jsxs(Box, { css: gridWithMargin, children: [
      /* @__PURE__ */ jsx(ReactSlider, { className: styledSlider, id, min, max, defaultValue: sliderValue, value: sliderValue, renderTrack: Track, renderThumb: (p, s) => {
        const {
          key,
          ...thumbProps
        } = p;
        return /* @__PURE__ */ jsx(Thumb, { props: thumbProps, state: s, id, percentageQuestion }, key);
      }, step, onChange: (e) => onChange(e), onAfterChange: () => {
        if (onAfterChange) onAfterChange();
      } }),
      /* @__PURE__ */ jsxs(Box, { css: gridWithPadding, children: [
        /* @__PURE__ */ jsx(Box, { children: percentageQuestion ? `${min}%` : `$${min}` }),
        /* @__PURE__ */ jsx(Box, { css: gridEnd, children: percentageQuestion ? `${max}%` : `$${currencyFormatter(max, 2)}` })
      ] })
    ] }) });
  }, [sliderValue, defaultValue, id, sliderQuestion, toolTipHeader, toolTipStatement, min, max, percentageQuestion, step, onAfterChange, onChange]);
  return /* @__PURE__ */ jsx(Box, { css: formFieldWrapper, children: formField });
};
export {
  CustomSlider as default
};
